<template>
  <fragment>
    <template v-for="(item, index) in items">
      <div class="divider is-form-divider is-blue" v-if="index > 0" :key="item.value"></div>
      <div class="columns is-multiline" :key="item.value">
        <ws-request-exam-type-form-item
          v-for="type in item"
          :key="type.value"
          :items="items"
          :title="type.title"
          :subtitle="type.subtitle"
          :parents="type.parents"
          :value="type.value"
          :model="newModel"
          :level="index"
          @input="onInput"
        >
        </ws-request-exam-type-form-item>
      </div>
    </template>
  </fragment>
</template>

<script>
export default {
  name: 'WsRequestExamTypeForm',
  $_veeValidate: {
    name () {
      return this.name
    },
    value () {
      return this.value
    }
  },
  props: {
    items: Array,
    value: Array,
    name: String
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (model) {
        this.newModel = Array.isArray(model) ? model : []
      }
    }
  },
  data: function () {
    return {
      newModel: []
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
